import { type ReactElement } from 'react'
import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Tooltip as MuiTooltip,
  type TooltipProps,
} from '@mui/material'
import { Ellipsis } from '../Ellipsis'

type Props = Pick<TooltipProps, 'children' | 'open' | 'onOpen' | 'onClose'> & {
  /**
   * The actual tooltip text, for example we assume `t('common.foo')` or `<Trans .../>` or something with a Link
   * we maximize it over 4 lines
   */
  title: string | ReactElement

  /**
   * Placement of the tooltip
   * @default 'bottom'
   */
  placement?: Pick<TooltipProps, 'placement'>['placement'] & ('top' | 'bottom' | 'left' | 'right')
}

export const Tooltip = ({ children, title, ...rest }: Props) => (
  <MuiTooltip
    title={
      <Ellipsis lineClamp={4} variant="body2">
        {title}
      </Ellipsis>
    }
    {...rest}
    arrow
  >
    {children}
  </MuiTooltip>
)
